import { ViewTypeControl } from 'admination-react'
import type { ViewType } from '@/core/lib/viewTypePrefs'

const VIEW_TYPE_OPTIONS: { value: ViewType; label: string; icon: string }[] = [
  { value: 'board', label: "Board", icon: 'i-board' },
  { value: 'list', label: "Liste", icon: 'i-list' },
]

export function ViewTypeMenu({ value, onChange }: { value: ViewType; onChange: (v: ViewType) => void }) {
  return (
    <ViewTypeControl
      options={VIEW_TYPE_OPTIONS}
      value={value}
      onChange={(v) => onChange(v as ViewType)}
      label="Ansicht"
    />
  )
}
